export default __webpack_public_path__ + "static/media/The E Major.30e6ccc9.png";